import { call, put, takeEvery } from 'redux-saga/effects';
import { TRANSACTION_CONSTANTS } from '../constants/transactionConstants';
import { getTransactionsSuccess, getTransactionsFailure } from '../actions/transactionActions';
import { getTransactions } from '../../api/transactionApi';

function* getTransactionsSaga(action) {
  try {
    const response = yield call(getTransactions, action.payload);
    yield put(getTransactionsSuccess(response));
  } catch (error) {
    yield put(getTransactionsFailure(error.response?.data?.message || 'Failed to fetch transactions'));
  }
}

function* transactionSaga() {
  yield takeEvery(TRANSACTION_CONSTANTS.GET_TRANSACTIONS_REQUEST, getTransactionsSaga);
}

export default transactionSaga;